import React from 'react';
import { Link } from 'react-router-dom';


const NewsMain = () => {
    const cards = [
        {
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744560910/image_tiwgkm.png",
            label: "FARMER REGISTRATION",

            description: "Have you registered as a farmer",
            link: "/news",

        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744560910/image-1_kzlqxy.png",
link: "/new1",

            label: "URBAN FARMING",
            description: "Urban Farming in Namibia",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744560909/image-2_pokima.png",
            label: "SHEEP FARMING",
link: "/new2",
            description: "Sheep farming in Namibia",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744560910/image-3_lkomux.png",
            label: "AGRITECH",
            link: "/new3",
            description: "Women in Agriculture",


        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            link: "/argitech5",
            label: "FOOD SECURITY",

            description: "Innovation for\nsustainable future",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            link: "/argitech5",
            label: "SMART FARMING",
            description: "SMART Chicken farming",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            link: "/argitech4",
            label: "AGRITECH",
            description: "Agritech, the future of agriculture",
        },
        {
            logo: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744284098/farmnet-icon_udpzr2.png",
            title: "Revolutionizing Agriculture with Digital Solutions",
            subtitle: "Stay informed with insights and innovations in Agriculture",
            image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/Rectangle_34637092_s9qhwq.png",
            label: "AGRITECH",
            link: "/argitech4",
            description: "Agritech, the future of agriculture",
        },
    ];

    return (
        <div className='bg-white'>
            <div className="container mx-auto md:py-12 py-4 px-4 md:px-20">
                {/* Section Title with Icon */}
                <div className="flex justify-between items-center md:mb-8 mb-3">
                    <h1 className="font-inter font-bold text-[11px] md:text-4xl text-[#FDBD26]">NEWS</h1>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
                        alt="icon"
                        className="w-6 h-6 md:w-8 md:h-8 md:flex hidden"
                    />
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744416878/Expand_down_pm2tdq.png"
                        alt="icon"
                        className="w-4 h-4  md:hidden flex"
                    />
                </div>

                {/* Paragraph */}
                <p className="font-inter text-[11px] md:text-[40px] font-normal leading-snug md:leading-[1.30] md:mb-6 ">
                Agritech, or agricultural technology, refers to the application of technological innovations to improve and enhance agricultural practices. It is aimed at increasing productivity, sustainability, and efficiency in farming and food production.                </p>

                {/* Cards Grid */}
                <div className="grid grid-cols-2 gap-x-1 md:gap-x-16 md:gap-y-4 gap-y-1">
                    {cards.map((card, index) => (
                        <Link to={card.link} key={index}>
                            <div
                                key={index}
                                className={`group rounded-lg overflow-hidden transition-all duration-300 transform hover:scale-105 ${index < 2 ? 'pt-6 md:pt-10' : 'pt-3 md:pt-5'}`}
                            >


                                {/* Image + Overlay Text */}
                                <div className="relative">
    {/* Show Read More only on the 4th card (index 3) */}
    {index === 3 && (
        <div className="absolute top-1 left-1 md:top-2 md:left-2  text-black text-[8px] md:text-[14px] font-semibold px-2 md:px-3 py-[2px] md:py-1 rounded">
            Read More
        </div>
    )}

    <img
        src={card.image}
        alt="card image"
        className="md:w-[555px] h-[110px] w-[170px] md:h-[305px] w-full object-cover rounded-lg"
    />

    <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
        alt="Play"
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
    />

    <div className="absolute md:left-6 md:bottom-4 left-2 bottom-1 text-white">
        <h3 className="font-inter font-semibold text-[9px] md:text-[16px] md:mb-3">{card.label}</h3>
        <p className="font-inter font-bold text-[9px] md:text-[24px] whitespace-pre-line" style={{ lineHeight: '1.30' }}>
            {card.description}
        </p>
    </div>
</div>


                                
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <div className='md:h-5'></div>
        </div>
    );
};

export default NewsMain;
